import React, { FC, memo, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { Container, Content } from './styles'
import { FilterTransport } from '../../../../../transports/filters-configuration-transport'
import { FilterSectionTransport } from '../../../../../transports/search-result-listing-static-transport'
import { stopPropagation } from '../../../../../utils/dom-utils'
import Filter from '../../../filter-sort-section/filter'
import { FilterHeadPosition, FilterType } from '../../../filter-sort-section/types'
import { checkPriceFilterValidity } from '../../../filter-sort-section/utils'
import ErrorCard from '../../../../common/error-card'
import {
    fetchInitialFilters,
    getFilterError,
    getFiltersConfiguration,
    getRegionNodeId,
    getIsSpaMode,
} from '../../../../../redux/filters'
import { Dispatch } from '../../../../../redux/types'

import { useRequestUserConfigContext } from '../../../../../hooks/request'

type Props = {
    filterStaticData: FilterSectionTransport
}

import { usePopularFilters } from '../../../../../hooks/use-popular-filters'

const FilterContent: FC<Props> = ({ filterStaticData }) => {
    const filtersConfigurationResponse = useSelector(getFiltersConfiguration)
    const filtersError = useSelector(getFilterError)
    const user = useRequestUserConfigContext()
    const dispatch = useDispatch<Dispatch>()
    const regionNodeId = useSelector(getRegionNodeId)
    const spaMode = useSelector(getIsSpaMode)

    const onRetry = useCallback(() => {
        dispatch(fetchInitialFilters(user, regionNodeId, spaMode))
    }, [dispatch, user, regionNodeId, spaMode])

    const filters = filtersConfigurationResponse?.filters ?? []

    const popularFilters: FilterTransport = usePopularFilters(filterStaticData)

    if (filtersError) {
        return (
            <Container onMouseDown={stopPropagation}>
                <ErrorCard onButtonClick={onRetry} />
            </Container>
        )
    }

    return (
        <Container onMouseDown={stopPropagation}>
            <Content>
                {popularFilters.items.length > 0 ? (
                    <Filter
                        filter={popularFilters}
                        key={popularFilters.type}
                        filterStaticData={filterStaticData}
                        filterHeadPosition={FilterHeadPosition.MOBILE_FILTER}
                    />
                ) : null}
                {filters.map(filter => {
                    return (
                        (filter.type !== FilterType.PRICES || checkPriceFilterValidity(filter.items[0])) && (
                            <Filter
                                filter={filter}
                                key={filter.title}
                                filterStaticData={filterStaticData}
                                filterHeadPosition={FilterHeadPosition.MOBILE_FILTER}
                            />
                        )
                    )
                })}
            </Content>
        </Container>
    )
}

export default memo(FilterContent)
